module.exports = __webpack_public_path__ + "merch-211cadad85e9e82b1e96.png";